import { nextTick, ref } from "vue";
import PageModalTable from '@/components/PageModalTable.vue'
import { getPageListData } from '@/service/main/system'
import { ILoadingInstance } from "element-plus/lib/el-loading/src/loading.type";
import { ElLoading } from "element-plus";

type modalCallbackFn = (item?: any) => void

export function usePageModalTable(callBack?: modalCallbackFn) {
  const pageModalTableRef = ref<InstanceType<typeof PageModalTable>>()
  const defaultTableInfo = ref({})
  const dataList = ref([])
  const dataCount = ref(0)
  let loadingInstance: ILoadingInstance = {} as ILoadingInstance
  const handleViewClick = (row: any, url?: string) => {
    dataList.value = []
    dataCount.value = 0
    if (pageModalTableRef.value) {
      pageModalTableRef.value.dialogVisible = true
      loadingInstance = ElLoading.service({
        target: '.el-dialog__body'
      })
      defaultTableInfo.value = {}
      if ((!row.dataList || row.dataList.length == 0) && url) {
        getPageListData(url + '/' + row.id, {}).then((res) => {
          row.dataList = res.dataList
          dealWithData(row)
        })
      } else {
        dealWithData(row)
      }
    }
  }

  const dealWithData = (row: any) => {
    row.dataList.forEach((item: any) => {
      if (item.duration) {
        item.duration = Number(item.duration)
      }
    })
    dataList.value = row.dataList
    dataCount.value = row.dataList.length
    // if (pageModalTableRef.value) {
    //   pageModalTableRef.value.dialogVisible = true
    // }
    callBack && callBack(row)
    if (loadingInstance) {
      loadingInstance.close()
    }
  }

  const handleSortChange = (val: any) => {
    if (val.prop) {
      dataList.value.sort((a: any, b: any) => {
        if (val.order === 'ascending') {
          return a[val.prop] > b[val.prop] ? 1 : -1
        } else if (val.order === 'descending') {
          return a[val.prop] < b[val.prop] ? 1 : -1
        }
        return 0
      })
    }
  }
  return [
    pageModalTableRef,
    defaultTableInfo,
    dataList,
    handleViewClick,
    dataCount,
    handleSortChange
  ]
}
